export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اختر حساب العارض"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حساب العارض"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Account"])}
}